
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/about-us/refer-a-friend",
      function () {
        return require("private-next-pages/us/about-us/refer-a-friend/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/about-us/refer-a-friend"])
      });
    }
  